module.exports = __webpack_public_path__ + "static/media/traffic_red.e2d8ff0c.png";